function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9899 18.12C9.8499 18.12 7.7199 18.1 5.5799 18.12C4.5399 18.13 4.0299 17.32 4.2399 16.38C4.3399 15.95 4.5699 15.59 4.9199 15.32C5.1299 15.16 5.3399 15 5.5499 14.85C6.1499 14.4 6.4699 13.79 6.4799 13.05C6.4999 11.74 6.4999 10.43 6.4999 9.10998C6.4999 7.62998 7.0899 6.44998 8.2499 5.52998C8.8099 5.08998 9.4299 4.77999 10.0999 4.54999C10.5999 4.37999 10.6499 4.32999 10.6499 3.78999C10.6499 3.26999 10.7999 2.83998 11.2999 2.60998C11.8399 2.35998 12.3799 2.37998 12.8699 2.71998C13.1599 2.91998 13.2999 3.20998 13.3199 3.55998C13.3399 4.07998 13.5899 4.42998 14.0699 4.60998C15.0899 4.99998 15.9899 5.55999 16.6499 6.45999C17.1899 7.18999 17.4699 8.01999 17.4799 8.92999C17.4799 10.14 17.4799 11.36 17.4799 12.57C17.4799 12.88 17.5199 13.2 17.5699 13.5C17.6499 14.01 17.9199 14.42 18.3199 14.74C18.5699 14.94 18.8399 15.12 19.0899 15.33C19.6299 15.79 19.8999 16.37 19.7799 17.08C19.6599 17.74 19.2099 18.11 18.5299 18.11C16.3499 18.11 14.1699 18.11 11.9899 18.11V18.12Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8001 18.13C14.9301 19.52 13.6401 20.94 12.2101 21C10.7101 21.06 9.38008 19.69 9.43008 18.13H14.8001Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.adf5deb4.svg";
export { ForwardRef as ReactComponent };